// extracted by mini-css-extract-plugin
export default {"FinishedTestRow__Icon":"FinishedTestRow_FinishedTestRow__Icon__Mlt68"};